module.exports = __webpack_public_path__ + "static/media/banner.57fa3e11.png";